import React from "react";
import { Switch } from "react-router-dom";

import { PrivateRoute } from "./PrivateRoute";

// import {
//   HubListCarrier,
//   HubCreateCarrier,
//   HubUpdateCarrier,
// } from "pages/Hub/Carrier";

import {
  HubListDriver,
  HubCreateDriver,
  HubUpdateDriver,
} from "pages/Hub/Driver";
import {
  HubListVehicle,
  HubCreateVehicle,
  HubUpdateVehicle,
} from "pages/Hub/Vehicle";
import {
  HubListChecklistUser,
  HubCreateChecklistUser,
  HubUpdateChecklistUser,
} from "pages/Hub/ChecklistUser";

interface Props {}

export const HubRoutes: React.FC<Props> = () => {
  return (
    <Switch>
      {/* <PrivateRoute
        exact
        path="/settings/hub-carriers"
        component={HubListCarrier}
      />
      <PrivateRoute
        exact
        path="/settings/hub-carriers/new"
        component={HubCreateCarrier}
      />
      <PrivateRoute
        exact
        path="/settings/hub-carriers/edit/:id"
        component={HubUpdateCarrier}
      /> */}

      {/* Motorista */}
      <PrivateRoute
        exact
        path="/settings/hub-drivers"
        component={HubListDriver}
        hasPermission="accessDriverHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-drivers/new"
        component={HubCreateDriver}
        hasPermission="accessDriverHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-drivers/edit/:id"
        component={HubUpdateDriver}
        hasPermission="accessDriverHUB"
      />
      {/* Veiculos */}

      <PrivateRoute
        exact
        path="/settings/hub-vehicles"
        component={HubListVehicle}
        hasPermission="accessVehicleHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-vehicles/new"
        component={HubCreateVehicle}
        hasPermission="accessVehicleHUB"
      />
      <PrivateRoute
        exact
        path="/settings/hub-vehicles/edit/:id"
        component={HubUpdateVehicle}
        hasPermission="accessVehicleHUB"
      />

      {/* Cheslist USER */}

      <PrivateRoute
        exact
        path="/settings/hub-checklist-user"
        component={HubListChecklistUser}
      />
      <PrivateRoute
        exact
        path="/settings/hub-checklist-user/new"
        component={HubCreateChecklistUser}
      />
      <PrivateRoute
        exact
        path="/settings/hub-checklist-user/edit/:id"
        component={HubUpdateChecklistUser}
      />
    </Switch>
  );
};
